import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, Stack, useTheme } from "@mui/material";
import ScoutIcon from "components/ScoutIcon";
import { useState } from "react";

import { SearchThreadsDialog } from "./Search";

export function ScoutToolbar() {
  const theme = useTheme();
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <Stack
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 1,
      }}
    >
      <Box sx={{ padding: 1 }}>
        <ScoutIcon sx={{ color: theme.palette.encampBlue.main }} />
      </Box>

      <IconButton onClick={() => setSearchOpen(true)}>
        <SearchIcon />
      </IconButton>

      <SearchThreadsDialog
        key={String(searchOpen)}
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
      />
    </Stack>
  );
}
